import type { TableCellProps } from '@mui/material/TableCell';
import type { RowData } from '@tanstack/react-table';
import { getTableColumnDef } from '../internal/getTableColumnDef';
import type { TableColumn } from '../tanstackTypes';

export const getCellAlign = <TData extends RowData>(
  column: TableColumn<TData>
): TableCellProps['align'] => getTableColumnDef(column).meta?.align;
